import { useEffect, useState } from 'react'

const INITIAL_SECONDS = 23 * 3600 + 27 * 60 + 35

export type Countdown = {
  hours: string
  minutes: string
  seconds: string
}

const pad = (value: number): string => value.toString().padStart(2, '0')

export function useCountdown(): Countdown {
  const [remaining, setRemaining] = useState<number>(INITIAL_SECONDS)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 0 ? INITIAL_SECONDS : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
